import { render, staticRenderFns } from "./campaignForm.vue?vue&type=template&id=75520e39"
import script from "./campaignForm.vue?vue&type=script&lang=js"
export * from "./campaignForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports